var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-exam-wrap exemptionApplication" }, [
    _c("div", { staticClass: "uni-exam-pay" }, [
      _c(
        "div",
        { staticClass: "continer" },
        [
          _c("Title", { attrs: { text: "免考申请" } }),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "search",
                  staticClass: "search-form",
                  attrs: {
                    slot: "search",
                    inline: true,
                    model: _vm.condition,
                    rules: _vm.searchRules,
                    "label-width": "80px",
                  },
                  slot: "search",
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div"),
                      _c("div", [
                        _c("div", { staticClass: "btn-box" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: _vm.exemptionApplicationClick,
                                      },
                                    },
                                    [_vm._v("免考申请")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "elTabs" }, [
            _c(
              "div",
              { staticClass: "informationDiv" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.dataList,
                      headerRowClassName: "uni-primary-table-header",
                      stripe: "",
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "student_title",
                        align: "center",
                        label: "学生",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "student_code",
                        align: "center",
                        label: "学号",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "class_title",
                        align: "center",
                        label: "班级",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "", align: "center", label: "免考课程" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.courseClick(row)
                                    },
                                  },
                                },
                                [_vm._v("查看课程")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "", align: "center", label: "成绩单照片" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              !_vm.$base.isNull(row.transcript_img)
                                ? _c(
                                    "div",
                                    _vm._l(
                                      row.transcript_img.split(","),
                                      function (item, index) {
                                        return _c("el-image", {
                                          key: index,
                                          staticClass: "see-img",
                                          staticStyle: {
                                            "margin-right": "2px",
                                          },
                                          attrs: {
                                            src: item,
                                            "preview-src-list":
                                              row.transcript_img.split(","),
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        align: "center",
                        label: "身份证国徽面",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              !_vm.$base.isNull(row.identity_pros)
                                ? _c("el-image", {
                                    staticClass: "see-img",
                                    attrs: {
                                      src: row.identity_pros,
                                      "preview-src-list": [row.identity_pros],
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        align: "center",
                        label: "身份证人像面",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              !_vm.$base.isNull(row.identity_cons)
                                ? _c("el-image", {
                                    staticClass: "see-img",
                                    attrs: {
                                      src: row.identity_cons,
                                      "preview-src-list": [row.identity_cons],
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "", align: "center", label: "手写签名" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("img", {
                                staticStyle: {
                                  height: "40px",
                                  "object-fit": "contain",
                                },
                                attrs: { src: row.sign_img, alt: "" },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "apply_remark",
                        align: "center",
                        label: "申请理由",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "first_check_status",
                        align: "center",
                        label: "初审状态",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm._f("auditStatusStyle")(
                                      row.first_check_status
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("auditStatusFilter")(
                                          row.first_check_status
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "first_check_remarks",
                        align: "center",
                        label: "初审备注",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "is_check",
                        align: "center",
                        label: "终审状态",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm._f("auditStatusStyle")(
                                      row.is_check
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("auditStatusFilter")(
                                          row.is_check
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "check_remark",
                        align: "center",
                        label: "终审备注",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", width: "100", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.first_check_status == 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "font-size": "12px" },
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editClick(row)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _c("span", [_vm._v("--")]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-dialog",
            {
              staticClass: "exemptionCoursesPop",
              attrs: {
                title: "免考课程",
                visible: _vm.isShowExemptionCoursesPop,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowExemptionCoursesPop = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.exemptionCoursesList,
                        stripe: "",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "course_title",
                          align: "center",
                          label: "课程名称",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "final_score",
                          align: "center",
                          label: "总评成绩",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "score_source",
                          align: "center",
                          label: "成绩来源",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "20px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isShowExemptionCoursesPop = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              staticClass: "exemptionApplicationPop",
              attrs: {
                title: "免考申请",
                visible: _vm.isShowExemptionApplicationPop,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowExemptionApplicationPop = $event
                },
                close: _vm.exemptionApplicationPopClose,
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "exemptionApplicationPop",
                      attrs: {
                        model: _vm.exemptionApplicationPopData,
                        rules: _vm.exemptionApplicationPopRules,
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "30%" },
                              attrs: { label: "姓名", prop: "title" },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "姓名" },
                                model: {
                                  value: _vm.exemptionApplicationPopData.title,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "title",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "exemptionApplicationPopData.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "30%" },
                              attrs: { label: "学号", prop: "student_code" },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "学号" },
                                model: {
                                  value:
                                    _vm.exemptionApplicationPopData
                                      .student_code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "student_code",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "exemptionApplicationPopData.student_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "30%" },
                              attrs: { label: "班级", prop: "className" },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "班级" },
                                model: {
                                  value:
                                    _vm.exemptionApplicationPopData.className,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "className",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "exemptionApplicationPopData.className",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.exemptionApplicationPopData.course_data,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "flex" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "免考课程",
                                    prop: `course_data.${index}.course_id`,
                                    rules: {
                                      required: true,
                                      message: "请选择免考课程",
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "请选择免考课程",
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: item.course_id,
                                        callback: function ($$v) {
                                          _vm.$set(item, "course_id", $$v)
                                        },
                                        expression: "item.course_id",
                                      },
                                    },
                                    _vm._l(_vm.courseList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "20%" },
                                  attrs: {
                                    label: "学分",
                                    prop: `course_data.${index}.credit`,
                                    rules: {
                                      required: true,
                                      message: "请输入学分",
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "学分",
                                    },
                                    model: {
                                      value: item.credit,
                                      callback: function ($$v) {
                                        _vm.$set(item, "credit", $$v)
                                      },
                                      expression: "item.credit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "20%" },
                                  attrs: {
                                    label: "总评成绩",
                                    prop: `course_data.${index}.final_score`,
                                    rules: {
                                      required: true,
                                      message: "请输入总评成绩",
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "总评成绩",
                                    },
                                    model: {
                                      value: item.final_score,
                                      callback: function ($$v) {
                                        _vm.$set(item, "final_score", $$v)
                                      },
                                      expression: "item.final_score",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "20%" },
                                  attrs: {
                                    label: "成绩来源",
                                    prop: `course_data.${index}.score_source`,
                                    rules: {
                                      required: true,
                                      message: "请输入成绩来源",
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "成绩来源" },
                                    model: {
                                      value: item.score_source,
                                      callback: function ($$v) {
                                        _vm.$set(item, "score_source", $$v)
                                      },
                                      expression: "item.score_source",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "btn-box" }, [
                                index ==
                                _vm.exemptionApplicationPopData.course_data
                                  .length -
                                  1
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-circle-plus-outline btn btn-add",
                                      staticStyle: { color: "#5879ff" },
                                      on: { click: _vm.addCourseClick },
                                    })
                                  : _vm._e(),
                                index > 0
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-remove-outline btn btn-del",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeCourse(index)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          )
                        }
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "成绩单照片",
                                prop: "transcript_img",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadTranscriptImg",
                                attrs: {
                                  multiple: true,
                                  isShowModal: false,
                                  limit: 9,
                                  fileListData:
                                    _vm.exemptionApplicationPopData
                                      .transcript_img,
                                  isFileListData: true,
                                },
                                on: {
                                  handleRemove: _vm.transcriptImgRemove,
                                  handleChange: _vm.transcriptImgChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "身份证国徽面",
                                prop: "identity_pros",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadIdentityPros",
                                attrs: {
                                  isShowModal: false,
                                  fileListData:
                                    _vm.exemptionApplicationPopData
                                      .identity_pros,
                                  isFileListData: true,
                                },
                                on: {
                                  handleRemove: _vm.identityProsRemove,
                                  handleChange: _vm.identityProsChange,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "身份证人像面",
                                prop: "identity_cons",
                              },
                            },
                            [
                              _c("FalConUpload", {
                                ref: "uploadIdentityCons",
                                attrs: {
                                  isShowModal: false,
                                  fileListData:
                                    _vm.exemptionApplicationPopData
                                      .identity_cons,
                                  isFileListData: true,
                                },
                                on: {
                                  handleRemove: _vm.identityConsRemove,
                                  handleChange: _vm.identityConsChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "手写签名:", prop: "sign_img" } },
                            [
                              _c("esignHandle", {
                                ref: "esignHandle",
                                attrs: {
                                  selectSignImg:
                                    _vm.exemptionApplicationPopData.sign_img,
                                  isShowCurrSignImg: true,
                                },
                                on: {
                                  "update:selectSignImg": function ($event) {
                                    return _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "sign_img",
                                      $event
                                    )
                                  },
                                  "update:select-sign-img": function ($event) {
                                    return _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "sign_img",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: {
                                label: "申请理由",
                                prop: "apply_remark",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  rows: 3,
                                  type: "textarea",
                                  resize: "none",
                                  clearable: "",
                                  placeholder: "申请理由",
                                },
                                model: {
                                  value:
                                    _vm.exemptionApplicationPopData
                                      .apply_remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.exemptionApplicationPopData,
                                      "apply_remark",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "exemptionApplicationPopData.apply_remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.isShowExemptionApplicationPop = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.exemptionApplicationPopLoading,
                      },
                      on: { click: _vm.exemptionApplicationPopSubmit },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }